export const ACE_UTIL = {
  initEditor: function (id, language) {
    window.ace.require('ace/ext/language_tools')
    window.ace.config.set('basePath', '/assets/javascript/ace')

    let editor = window.ace.edit(id)
    editor.setTheme('ace/theme/tomorrow_night')

    if (language) {
      editor.getSession().setMode('ace/mode/' + language)
    }

    editor.renderer.setShowGutter(false)
    editor.renderer.setAnimatedScroll(true)
    editor.renderer.setShowPrintMargin(false)

    editor.setOptions({
      enableBasicAutocompletion: true,
      enableSnippets: true,
      enableLiveAutocompletion: false
    })
    editor.$blockScrolling = Infinity
    return editor
  },
  heightChangeFunction: function (id) {
    let editor = window.ace.edit(id)
    let newHeight = editor.getSession().getScreenLength() * editor.renderer.lineHeight +
      editor.renderer.scrollBar.getWidth()

    if (id === 'output') {
      newHeight += 40
    } else {
      newHeight += 20
    }

    $('#' + id).height(newHeight.toString() + 'px')
    editor.resize()
  },
  changeLanguage: function (editor, language) {
    if (language) {
      editor.getSession().setMode('ace/mode/' + language)
      if (this.language === 'whitespace') {
        editor.setShowInvisibles(true)
      } else {
        editor.setShowInvisibles(false)
      }
    }
  }
}
